module.exports = __webpack_public_path__ + "static/media/add-coupon.0ef1738d.png";